export const customerMT = []

export function start() {}
